import { create } from "zustand";

const useContactBoxStore = create((set) => ({
  isDialogBoxOpen: false,
  updateContactDialogBoxOpen: (newDialogBoxOpen) => set({ isDialogBoxOpen: newDialogBoxOpen })
}));

export default useContactBoxStore;
